import {
  // Admin constants
  ADMIN_USERS_REQUEST,
  ADMIN_USERS_SUCCESS,
  ADMIN_USERS_FAIL,
  //
  ADMIN_USER_DETAILS_REQUEST,
  ADMIN_USER_DETAILS_SUCCESS,
  ADMIN_USER_DETAILS_FAIL,
  //
  ADMIN_UPDATE_USER_REQUEST,
  ADMIN_UPDATE_USER_SUCCESS,
  ADMIN_UPDATE_USER_RESET,
  ADMIN_UPDATE_USER_FAIL,
  //
  ADMIN_DELETE_USER_REQUEST,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_RESET,
  ADMIN_DELETE_USER_FAIL,
  //
  PRE_SIGNUP_REQUEST,
  PRE_SIGNUP_SUCCESS,
  PRE_SIGNUP_FAIL,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_SUCCESS_GOOGLE,
  CLEAR_MESSAGE,
  LOGIN_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_RESET,
  //
  DEACTIVATE_USER_ACCOUNT_REQUEST,
  DEACTIVATE_USER_ACCOUNT_SUCCESS,
  DEACTIVATE_USER_ACCOUNT_RESET_SUCCESS,
  DEACTIVATE_USER_ACCOUNT_FAIL,
  DEACTIVATE_USER_ACCOUNT_CLEAR_ERRORS,
  //
  DELETE_USER_ACCOUNT_REQUEST,
  DELETE_USER_ACCOUNT_SUCCESS,
  DELETE_USER_ACCOUNT_RESET_SUCCESS,
  DELETE_USER_ACCOUNT_FAIL,
  DELETE_USER_ACCOUNT_CLEAR_ERRORS,
  //
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_RESET,
  CHANGE_USER_PASSWORD_FAIL,
  //
  FORGOT_USER_PASSWORD_REQUEST,
  FORGOT_USER_PASSWORD_SUCCESS,
  FORGOT_USER_PASSWORD_CLEAR_SUCCESS,
  FORGOT_USER_PASSWORD_FAIL,
  //
  RESET_USER_PASSWORD_REQUEST,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAIL,
  CLEAR_ERRORS,
} from "../constants/userConstants";

export const userReducers = (
  state = {
    user: {},
    // isAuthenticated: false,
    // message: "",
    // loading: false,
    // success: false,
    // error: null,
    // adminOut: false,
    // reqState: "",
  },
  action
) => {
  switch (action.type) {
    case PRE_SIGNUP_REQUEST:
    case SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PRE_SIGNUP_SUCCESS:
    case SIGNUP_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload.success,
        successVerify: action.payload && action.payload.successVerify,
        message: action.payload && action.payload.message,
        verifyUrl: action.payload && action.payload.verifyUrl,
        token: action.payload && action.payload.token,
        loading: false,
      };
    case PRE_SIGNUP_FAIL:
    case SIGNUP_FAIL:
      return {
        ...state,
        success: false,
        successVerify: false,
        message: "",
        verifyUrl: "",
        token: "",
        messageGoogle: "",
        error: action.payload && action.payload,
        loading: false,
      };
    case LOGIN_REQUEST:
    case LOAD_USER_REQUEST:
      return {
        ...state,
        loading: true,
        reqState: "pending",
      };
    case LOGIN_SUCCESS:
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        user: action.payload && action.payload,
        isAuthenticated: true,
        loading: false,
        reqState: "success",
      };
    case LOGIN_SUCCESS_GOOGLE:
      return {
        ...state,
        user: action.payload && action.payload.user && action.payload.user,
        messageGoogle:
          action.payload &&
          action.payload.messageGoogle &&
          action.payload.messageGoogle,
        isAuthenticated: true,
        loading: false,
        reqState: "success",
      };
    case LOGIN_FAIL:
    case LOAD_USER_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        error: action.payload && action.payload,
        loading: false,
        reqState: "fail",
        // success: false,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: null,
        user: null,
        adminOut: action.payload && action.payload.adminOut,
        loading: false,
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };

    // case RESET_USER_SUCCESS:
    //   return {
    //     ...state,
    //     success: null,
    //   };
    case CLEAR_MESSAGE:
      return {
        ...state,
        message: "",
        messageGoogle: "",
        success: false,
        successVerify: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Edit profile
export const userEditReducers = (
  state = { isUpdated: null, loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case EDIT_USER_REQUEST:
    case CHANGE_USER_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_USER_SUCCESS:
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        isUpdated: action.payload && action.payload,
        loading: false,
      };
    case EDIT_USER_RESET:
    case CHANGE_USER_PASSWORD_RESET:
      return {
        ...state,
        isUpdated: null,
      };
    case EDIT_USER_FAIL:
    case CHANGE_USER_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// Edit profile
export const userDeleteOrDeactivateAccountReducer = (
  state = { loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case DELETE_USER_ACCOUNT_REQUEST:
    case DEACTIVATE_USER_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_USER_ACCOUNT_SUCCESS:
    case DEACTIVATE_USER_ACCOUNT_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload,
        loading: false,
      };
    case DELETE_USER_ACCOUNT_RESET_SUCCESS:
    case DEACTIVATE_USER_ACCOUNT_RESET_SUCCESS:
      return {
        ...state,
        success: null,
      };
    case DELETE_USER_ACCOUNT_FAIL:
    case DEACTIVATE_USER_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case DELETE_USER_ACCOUNT_CLEAR_ERRORS:
    case DEACTIVATE_USER_ACCOUNT_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// User forgot password
export const userForgotPasswordReducer = (
  state = {
    forgotSuccess: null,
    message: "",
    loading: false,
    success: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case FORGOT_USER_PASSWORD_REQUEST:
    case RESET_USER_PASSWORD_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case FORGOT_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotSuccess: action.payload && action.payload.success,
        message: action.payload && action.payload.message,
        loading: false,
      };
    case RESET_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload,
        loading: false,
      };
    case FORGOT_USER_PASSWORD_CLEAR_SUCCESS:
      return {
        ...state,
        forgotSuccess: null,
        message: null,
        success: null,
      };
    case FORGOT_USER_PASSWORD_FAIL:
    case RESET_USER_PASSWORD_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// For Admin ============================================

export const allUsersAdminReducer = (
  state = { users: [], loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case ADMIN_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        users: [],
      };

    case ADMIN_USERS_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload.success,
        users: action.payload && action.payload.users,
        loading: false,
      };
    case ADMIN_USERS_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const userDetailsAdminReducer = (
  state = { user: {}, loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case ADMIN_USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_USER_DETAILS_SUCCESS:
      return {
        ...state,
        success: action.payload && action.payload.success,
        user: action.payload && action.payload.user,
        loading: false,
      };
    case ADMIN_USER_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload && action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const userUpDeAdminReducer = (
  state = {
    isUpdated: null,
    isDeleted: null,
    loading: false,
    success: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case ADMIN_UPDATE_USER_REQUEST:
    case ADMIN_DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdated: action.payload && action.payload,
        loading: false,
      };
    case ADMIN_DELETE_USER_SUCCESS:
      return {
        ...state,
        isDeleted: action.payload && action.payload,
        loading: false,
      };
    case ADMIN_DELETE_USER_FAIL:
    case ADMIN_UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload && action.payload,
        loading: false,
      };
    case ADMIN_UPDATE_USER_RESET:
      return {
        ...state,
        isUpdated: null,
      };
    case ADMIN_DELETE_USER_RESET:
      return {
        ...state,
        isDeleted: null,
      };
    default:
      return state;
  }
};
